import api from './api';
import { Occurrence, Resolution, Stats, Category, StatusHistory, OccurrencePriority } from '../types';

export const categoryService = {
  async findByCity(cityId: string): Promise<Category[]> {
    const { data } = await api.get<Category[]>(`/categories/city/${cityId}`);
    return data;
  },
};

export const occurrenceService = {
  async create(data: { description: string; categoryId: string; lat: number; lng: number; images: string[]; address?: string }): Promise<Occurrence> {
    const { data: res } = await api.post<Occurrence>('/occurrences', data);
    return res;
  },

  async uploadFiles(files: File[]): Promise<{ url: string; name: string }[]> {
    const form = new FormData();
    files.forEach((f) => form.append('files', f));
    const token = localStorage.getItem('geoz_token');
    const res = await fetch('/api/upload', {
      method: 'POST',
      headers: token ? { Authorization: `Bearer ${token}` } : {},
      body: form,
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.message || 'Erro ao enviar arquivos');
    }
    return res.json();
  },

  async findAll(): Promise<Occurrence[]> {
    const { data } = await api.get<Occurrence[]>('/occurrences');
    return data;
  },

  async findOne(id: string): Promise<Occurrence> {
    const { data } = await api.get<Occurrence>(`/occurrences/${id}`);
    return data;
  },

  async updateStatus(id: string, status: string): Promise<Occurrence> {
    const { data } = await api.patch<Occurrence>(`/occurrences/${id}/status`, { status });
    return data;
  },

  async updatePriority(id: string, priority: OccurrencePriority): Promise<Occurrence> {
    const { data } = await api.patch<Occurrence>(`/occurrences/${id}/priority`, { priority });
    return data;
  },

  async updateCategory(id: string, categoryId: string): Promise<Occurrence> {
    const { data } = await api.patch<Occurrence>(`/occurrences/${id}/category`, { categoryId });
    return data;
  },

  async assignToTeam(id: string, assignedTo: string): Promise<Occurrence> {
    const { data } = await api.patch<Occurrence>(`/occurrences/${id}/assign`, { assignedTo });
    return data;
  },

  async getStats(): Promise<Stats> {
    const { data } = await api.get<Stats>('/occurrences/stats/summary');
    return data;
  },

  async remove(id: string): Promise<void> {
    await api.delete(`/occurrences/${id}`);
  },

  async getStatusHistory(id: string): Promise<StatusHistory[]> {
    const { data } = await api.get<StatusHistory[]>(`/occurrences/${id}/status-history`);
    return data;
  },
};

export const resolutionService = {
  async create(data: Partial<Resolution>): Promise<Resolution> {
    const { data: res } = await api.post<Resolution>('/resolutions', data);
    return res;
  },

  async findByOccurrence(occurrenceId: string): Promise<Resolution> {
    const { data } = await api.get<Resolution>(`/resolutions/occurrence/${occurrenceId}`);
    return data;
  },
};